import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { IconSize } from '@databox/icons/dist/types';

import type { Service } from 'webapp-types';
import { Size } from 'webapp/enums/enums';

import themed from 'webapp/decorators/themed';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	text?: string;
	theme?: string;
	size?: string; // supported sizes: normal, small
	openChat?: () => void;
}

@themed()
export default class CommonGenieButtonComponent extends Component<Args> {
	@service('ai-chat') declare aiChatService: Service.AIChat;

	declare themeClass: string; // from @themed
	declare sizeClass: string; // from @themed

	get buttonText(): string {
		return this.args.text ?? 'Analyze with AI';
	}

	get isButtonDisabled(): boolean {
		return this.aiChatService.isOpen;
	}

	get buttonClassNames(): string {
		const classes = ['genie-btn'];

		if (this.isButtonDisabled) {
			classes.push('genie-btn--disabled');
		}

		classes.push(this.themeClass, this.sizeClass);

		return classes.join(' ');
	}

	get buttonIconSize(): IconSize {
		let buttonIconSize: IconSize = 'md';
		if (this.args.size === Size.SMALL) {
			buttonIconSize = 'sm';
		}

		return buttonIconSize;
	}

	@action
	openChat(): void {
		if (this.args.openChat) {
			this.args.openChat();
		} else {
			this.aiChatService.openChat();
		}
	}

	<template>
		<a role="button" class={{this.buttonClassNames}} {{on "click" this.openChat}}>
			<CommonUiIconComponent
				@name="Genie"
				@size={{this.buttonIconSize}}
				@gradient="orange-violet"
			/>
			<span class="genie-btn__text">{{this.buttonText}}</span>
		</a>
	</template>
}
